/* =========================================================================
   somnair-cd.js — comportements de la famille « Vision Drops ».

   Regle tenue de bout en bout : AUCUN prix n'est formate ici. Les montants sont
   pre-rendus en Liquid, en arithmetique entiere sur des centimes, et le JS ne
   fait que recopier des chaines deja calculees. C'est ce qui rend impossible
   d'afficher un prix different de celui qui sera facture.
   ========================================================================= */
(function () {
  'use strict';

  var scope = document.querySelector('.smcd-scope');
  if (!scope) return;

  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ---------------------------------------------------------------- NAV */
  var nav = $('[data-smcd-nav]');
  if (nav) {
    var open = function (v) {
      nav.classList.toggle('is-open', v);
      document.documentElement.style.overflow = v ? 'hidden' : '';
    };
    $$('[data-smcd-nav-open]').forEach(function (b) {
      b.addEventListener('click', function () { open(true); });
    });
    $$('[data-smcd-nav-close]').forEach(function (b) {
      b.addEventListener('click', function () { open(false); });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') open(false);
    });
  }

  /* ---------------------------------------------------------------- FAQ */
  $$('[data-smcd-faq-q]').forEach(function (q) {
    q.addEventListener('click', function (e) {
      e.preventDefault();
      var it = q.closest('.smcd-faq__it');
      if (it) it.classList.toggle('is-open');
    });
  });

  /* -------------------------------------------------- CARROUSEL COLLECTION */
  $$('[data-smcd-track]').forEach(function (track) {
    var root = track.closest('section') || document;
    var go = function (dir) {
      // scrollBy d'une "colonne" : la largeur reelle d'une carte + le gap.
      var first = track.firstElementChild;
      if (!first) return;
      var gap = parseFloat(getComputedStyle(track).columnGap || '0') || 0;
      track.scrollBy({ left: dir * (first.getBoundingClientRect().width + gap), behavior: 'smooth' });
    };
    $$('[data-smcd-prev]', root).forEach(function (b) {
      b.addEventListener('click', function () { go(-1); });
    });
    $$('[data-smcd-next]', root).forEach(function (b) {
      b.addEventListener('click', function () { go(1); });
    });
  });

  /* --------------------------------------------- ACCORDEONS DE BUY BOX */
  $$('[data-smcd-acc]').forEach(function (b) {
    b.addEventListener('click', function () {
      var it = b.closest('.smcd-acc');
      if (!it) return;
      var open = it.classList.toggle('is-open');
      b.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });

  /* ------------------------------------------- DEPLIANTS DE L'ADVERTORIAL */
  $$('[data-smcd-acc2]').forEach(function (b) {
    b.addEventListener('click', function () {
      var it = b.parentElement;
      if (!it) return;
      var open = it.classList.toggle('is-open');
      b.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });

  /* ------------------------------------------------- PASTILLES DE GALERIE */
  /* La pastille active suit le defilement REEL de la piste, elle n'est pas
     pilotee par un compteur interne : un glissement tactile, un clic sur une
     fleche et un scroll au clavier donnent donc tous le meme etat. */
  $$('[data-smcd-gal]').forEach(function (gal) {
    var track = $('[data-smcd-gal-track]', gal);
    var dots = $$('.smcd-gal__dot', gal);
    if (!track || !dots.length) return;

    var sync = function () {
      var w = track.clientWidth || 1;
      var i = Math.round(track.scrollLeft / w);
      if (i < 0) i = 0;
      if (i > dots.length - 1) i = dots.length - 1;
      dots.forEach(function (d, k) { d.classList.toggle('is-on', k === i); });
    };

    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () { sync(); ticking = false; });
    }, { passive: true });

    var thumbs = $$('.smcd-gal__th', gal);
    var goTo = function (k) {
      track.scrollTo({ left: k * track.clientWidth, behavior: 'smooth' });
    };
    dots.forEach(function (d, k) { d.addEventListener('click', function () { goTo(k); }); });
    thumbs.forEach(function (t, k) { t.addEventListener('click', function () { goTo(k); }); });

    /* La vignette active suit le meme etat que la pastille : une seule source. */
    var syncAll = function () {
      sync();
      var w = track.clientWidth || 1;
      var i = Math.round(track.scrollLeft / w);
      thumbs.forEach(function (t, k) { t.classList.toggle('is-on', k === i); });
    };
    track.addEventListener('scroll', syncAll, { passive: true });
    syncAll();
  });

  /* ------------------------------------------------- BARRE ATC COLLANTE */
  /* Visible uniquement quand le vrai bouton d'ajout est SORTI de l'ecran :
     un IntersectionObserver sur ce bouton, pas un seuil de scroll en pixels —
     un seuil serait faux des que la hauteur de la buy box change. */
  var sticky = $('[data-smcd-sticky]');
  var realAtc = $('[data-smcd-atc]');
  if (sticky && realAtc && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { sticky.classList.toggle('is-on', !e.isIntersecting); });
    }, { rootMargin: '0px 0px -40px 0px' }).observe(realAtc);
  }

  /* ------------------------------------------------------------- PALIERS */
  var buy = $('[data-smcd-buy]');
  if (buy) {
    var subToggle = $('[data-smcd-sub]', buy);
    var atc = $('[data-smcd-atc]', buy);

    var selectedTier = function () { return $('.smcd-tier.is-on', buy); };
    var subOn = function () { return !!(subToggle && subToggle.classList.contains('is-on')); };

    /* Chaque palier porte SES DEUX jeux de montants, pre-rendus par le Liquid :
       data-*-otp = achat unique, data-*-sub = abonnement. Basculer l'abonnement
       ne recalcule rien, ca echange deux chaines.

       Pourquoi ca compte : sur la reference, `subscribeByDefault` est a true,
       donc les prix affiches par defaut sont ceux de l'ABONNEMENT ($55.99), pas
       du one-time ($69.99). Lire les prix a l'ecran sans le savoir produit une
       grille fausse — c'est le piege du playbook, ici rendu impossible. */
    /* La barre collante lit le MEME palier et le MEME etat que la buy box. Elle
       etait figee sur l'achat unique du palier preselectionne : l'abonnement etant
       coche par defaut, elle contredisait la buy box des le chargement, et changer
       de palier ne la bougeait pas (audit du 07/08). Aucun calcul ici non plus —
       le pourcentage est pre-rendu en Liquid, comme les montants. */
    var stickyNow = $('[data-smcd-sticky-now]');
    var stickyWas = $('[data-smcd-sticky-was]');
    var stickySave = $('[data-smcd-sticky-save]');

    var paint = function () {
      var key = subOn() ? 'Sub' : 'Otp';
      $$('.smcd-tier', buy).forEach(function (t) {
        var pr = $('[data-smcd-price]', t);
        var was = $('[data-smcd-was]', t);
        var sv = $('[data-smcd-save]', t);
        if (pr && t.dataset['price' + key]) pr.textContent = t.dataset['price' + key];
        if (was && t.dataset['wasOtp']) was.textContent = t.dataset['wasOtp'];
        if (sv && t.dataset['save' + key]) sv.textContent = t.dataset['save' + key];
      });

      var t = selectedTier();
      if (t && stickyNow) {
        stickyNow.textContent = t.dataset['price' + key] || '';
        if (stickyWas) stickyWas.textContent = t.dataset['wasOtp'] || '';
        if (stickySave) stickySave.textContent = t.dataset['off' + key] || '';
      }
      if (atc) atc.disabled = !t;
    };

    $$('.smcd-tier', buy).forEach(function (tier) {
      var pick = function () {
        $$('.smcd-tier', buy).forEach(function (o) { o.classList.remove('is-on'); });
        tier.classList.add('is-on');
        var input = $('input', tier);
        if (input) input.checked = true;
        paint();
      };
      tier.addEventListener('click', pick);
      tier.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); pick(); }
      });
    });

    if (subToggle) {
      subToggle.addEventListener('click', function () {
        subToggle.classList.toggle('is-on');
        paint();
      });
    }

    paint();

    /* ------------------------------------------------------------- ATC */
    if (atc) {
      atc.addEventListener('click', function () {
        var tier = selectedTier();
        if (!tier) return;
        var id = tier.dataset.variant;
        var qty = parseInt(tier.dataset.qty || '1', 10) || 1;
        if (!id) return;

        var body = { items: [{ id: Number(id), quantity: qty }] };
        var plan = subOn() ? tier.dataset.plan : '';
        if (plan) body.items[0].selling_plan = Number(plan);

        atc.disabled = true;
        var label = atc.textContent;
        atc.textContent = 'Adding…';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify(body)
        })
          .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
          .then(function (res) {
            atc.disabled = false;
            atc.textContent = label;
            if (!res.ok) {
              // Ne jamais avaler l'erreur en silence : un 422 « publish » ou un
              // stock epuise doit se voir, pas laisser le bouton muet.
              alert((res.j && (res.j.description || res.j.message)) || 'Could not add to cart.');
              return;
            }
            openCart();
          })
          .catch(function () {
            atc.disabled = false;
            atc.textContent = label;
            window.location.href = '/cart';
          });
      });
    }
  }

  /* Ouvre le tiroir du theme s'il existe, sinon replie sur /cart. Le tiroir est
     un fichier PARTAGE : on ne le modifie pas, on l'utilise. */
  function openCart() {
    var drawer = document.querySelector('cart-drawer');
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    if (drawer && typeof drawer.open === 'function') {
      // Le tiroir doit relire /cart.js avant de s'ouvrir, sinon il montre l'etat
      // precedent (panier vide au premier ajout).
      fetch('/?sections=cart-drawer')
        .then(function (r) { return r.json(); })
        .then(function (s) {
          var html = s['cart-drawer'];
          if (html) {
            var tmp = document.createElement('div');
            tmp.innerHTML = html;
            var fresh = tmp.querySelector('cart-drawer');
            if (fresh) drawer.innerHTML = fresh.innerHTML;
          }
          drawer.classList.remove('is-empty');
          drawer.open();
        })
        .catch(function () { drawer.open(); });
      return;
    }
    window.location.href = '/cart';
  }

  /* ------------------------------------------------------ REVEALS AU SCROLL */
  var animated = $$('[data-smcd-anim]').filter(function (n) {
    return !n.classList.contains('smcd-ts__row');   // le marquee s'auto-revele
  });
  if (animated.length) {
    if (!('IntersectionObserver' in window)) {
      animated.forEach(function (n) { n.classList.add('is-in'); });
    } else {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
        });
      }, { rootMargin: '0px 0px -50px 0px' });
      animated.forEach(function (n) { io.observe(n); });
    }
  }

  /* --------------------------------------------------------------- MARQUEE */
  /* La bande doit contenir DEUX copies de la liste pour que la translation de
     -50 % boucle sans saut. On duplique ici plutot que dans le Liquid : le
     gabarit reste la source unique du contenu. */
  $$('.smcd-ts__row').forEach(function (row) {
    if (row.dataset.smcdDup === '1') return;
    row.innerHTML += row.innerHTML;
    row.dataset.smcdDup = '1';
  });
})();
